import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TooltipMargin from './TooltipMargin';
import ClientProvider from './client';
export default createDemo(import.meta.url, TooltipMargin, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/tooltips/demos/margin/TooltipMargin.tsx",
    "fileName": "TooltipMargin.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Button from '@mui/material/Button';\nimport Tooltip, { tooltipClasses } from '@mui/material/Tooltip';\n\nexport default function TooltipMargin() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Tooltip\n      title=\"Add\"\n      describeChild\n      slotProps={{\n        popper: {\n          sx: {\n            [`&.${tooltipClasses.popper}[data-popper-placement*=\"bottom\"] .${tooltipClasses.tooltip}`]:\n              {\n                marginTop: '0px',\n              },\n            [`&.${tooltipClasses.popper}[data-popper-placement*=\"top\"] .${tooltipClasses.tooltip}`]:\n              {\n                marginBottom: '0px',\n              },\n            [`&.${tooltipClasses.popper}[data-popper-placement*=\"right\"] .${tooltipClasses.tooltip}`]:\n              {\n                marginLeft: '0px',\n              },\n            [`&.${tooltipClasses.popper}[data-popper-placement*=\"left\"] .${tooltipClasses.tooltip}`]:\n              {\n                marginRight: '0px',\n              },\n          },\n        },\n      }}\n    >\n      <Button>Margin</Button>\n    </Tooltip>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 35,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Button from '@mui/material/Button';\nimport Tooltip, { tooltipClasses } from '@mui/material/Tooltip';\n\nexport default function TooltipMargin() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Tooltip\n      title=\"Add\"\n      describeChild\n      slotProps={{\n        popper: {\n          sx: {\n            [`&.${tooltipClasses.popper}[data-popper-placement*=\"bottom\"] .${tooltipClasses.tooltip}`]:\n              {\n                marginTop: '0px',\n              },\n            [`&.${tooltipClasses.popper}[data-popper-placement*=\"top\"] .${tooltipClasses.tooltip}`]:\n              {\n                marginBottom: '0px',\n              },\n            [`&.${tooltipClasses.popper}[data-popper-placement*=\"right\"] .${tooltipClasses.tooltip}`]:\n              {\n                marginLeft: '0px',\n              },\n            [`&.${tooltipClasses.popper}[data-popper-placement*=\"left\"] .${tooltipClasses.tooltip}`]:\n              {\n                marginRight: '0px',\n              },\n          },\n        },\n      }}\n    >\n      <Button>Margin</Button>\n    </Tooltip>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 35,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Button",
      "@mui/material/Tooltip"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
